<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <form @submit.prevent="save">
        <div class="flex flex-col w-full mt-2">
          <label for="carrier">Paquetería</label>
          <input id="carrier" v-model="form.carrier" />
          <validation-errors :errors="errorFor('carrier')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="tracking_number">URL de rastreo</label>
          <input id="tracking_number" v-model="form.tracking_number" />
          <validation-errors
            :errors="errorFor('tracking_number')"
          ></validation-errors>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm">
          Guardar
        </primary-button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
import api from "@/api";
export default {
  name: "Tracking Info Modal",

  data() {
    return {
      form: {
        carrier: null,
        tracking_number: null,
      },
      loading: false,
    };
  },

  props: {
    order: Object,
  },

  mixins: [validationErrors],

  created() {
    this.form.carrier = this.order.carrier;
    this.form.tracking_number = this.order.tracking_number;
  },

  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      // if (!this.validateForm()) {
      //   this.$store.dispatch(
      //     "errorSnack",
      //     "Favor de llenar todos los campos correctamente."
      //   );
      //   return;
      // }

      this.updateTrackingInfo();
    },

    validateForm() {
      this.errors = {};

      if (!this.form.carrier) {
        this.errors["carrier"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async updateTrackingInfo() {
      this.loadingForm = true;

      try {
        const response = await api.orders.updateTrackingInfo(
          this.order.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$emit("updateTrackingInfo");
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>